import { render } from "./WellPanel.vue?vue&type=template&id=83d61de4&scoped=true"
import script from "./WellPanel.vue?vue&type=script&lang=js"
export * from "./WellPanel.vue?vue&type=script&lang=js"

import "./WellPanel.vue?vue&type=style&index=0&id=83d61de4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d61de4"]])

export default __exports__